import _ from 'underscore'
import Backbone from 'backbone'
import TextTemplate from '../templates/text.tpl'

const ReportingNameView = Backbone.View.extend({
    tagName: 'span',
    className: 'user-name',
    initialize() {
        this.template = _.template(TextTemplate)
        this.listenTo(this.model, 'change', this.render)
    },
    render() {
        let text = 'Guest'
        if (this.model.get('firstname') !== null) {
            text = this.model.get('firstname') + ' ' + this.model.get('lastname')
        }
        this.$el.html(this.template({text: text}))
        return this
    }
})

export default ReportingNameView